import { getUnixTime } from "date-fns";

interface Activity {
  startsAt: number;
  endsAt: number;
}

interface BookingStructure<T> {
  upcoming: T[];
  past: T[];
}

export const restructureBookings = <T extends Activity>(activities: T[]) => {
  const newBookingsStructure: BookingStructure<T> = { upcoming: [], past: [] };
  if (!activities.length) {
    return newBookingsStructure;
  }

  const result = activities
    .sort((a, b) => {
      return a.startsAt < getUnixTime(new Date())
        ? b.startsAt - a.startsAt
        : a.startsAt - b.startsAt;
    })
    .reduce((acc, item) => {
      if (item.endsAt > getUnixTime(new Date())) {
        acc.upcoming.push(item);
      } else {
        acc.past.push(item);
      }
      return acc;
    }, newBookingsStructure);

  return result;
};
